import { render } from "./LangSwitch.vue?vue&type=template&id=1b53b882&scoped=true"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"

import "./LangSwitch.vue?vue&type=style&index=0&id=1b53b882&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b53b882"]])

export default __exports__